import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

/** The MCP clients (Claude, ChatGPT...) the user connected to their account in the current organization */
export const useMcpConnectionsQuery = () => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ["useMcpConnectionsQuery", apiClient.slug],

    queryFn: async () => {
      const res = await apiClient.mcp.listConnections();
      return res.result;
    },

    enabled: !!apiClient.slug
  });
};
